var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.customerId && _vm.customerId == 0 ? _c("a-tooltip", {
    attrs: {
      title: _vm.$t(_vm.currentRoute.meta.remark) || _vm.$t(_vm.currentRoute.meta.title),
      placement: "right"
    }
  }, [!_vm.currentRoute.hidden ? _c("a-menu-item", {
    key: _vm.currentRoute.path,
    staticClass: "ant-menu-submenu ant-menu-submenu-inline",
    on: {
      click: _vm.menuClick
    }
  }, [_c("router-link", {
    staticClass: "ant-menu-submenu-title",
    style: _vm.currentRoute.meta.icon ? "padding-left: 24px;" : "padding-left:48px",
    attrs: {
      to: _vm.currentRoute.path
    }
  }, [_vm.currentRoute.meta.icon ? _c("svg-icon", {
    attrs: {
      icon: _vm.currentRoute.meta.icon,
      size: 18
    }
  }) : _vm._e(), _c("span", {
    staticClass: "menu-title",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentRoute.meta.title)))])], 1)], 1) : _vm._e()], 1) : _vm._e(), !_vm.currentRoute.hidden && _vm.customerId && _vm.customerId != 0 ? _c("a-tooltip", {
    attrs: {
      title: _vm.$t(_vm.currentRoute.meta.title),
      placement: "right"
    }
  }, [!_vm.currentRoute.hidden && _vm.customerId && _vm.customerId != 0 ? _c("a-menu-item", {
    key: _vm.currentRoute.path,
    staticClass: "ant-menu-submenu ant-menu-submenu-inline",
    on: {
      click: _vm.menuClick
    }
  }, [_c("router-link", {
    staticClass: "ant-menu-submenu-title",
    style: _vm.currentRoute.meta.icon ? "padding-left: 24px;" : "padding-left:48px",
    attrs: {
      to: _vm.currentRoute.path
    }
  }, [_vm.currentRoute.meta.icon ? _c("svg-icon", {
    attrs: {
      icon: _vm.currentRoute.meta.icon,
      size: 18
    }
  }) : _vm._e(), _c("span", {
    staticClass: "menu-title",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentRoute.meta.title)))])], 1)], 1) : _vm._e()], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };